import { render } from "./flow-item.vue?vue&type=template&id=408d5652&scoped=true&ts=true"
import script from "./flow-item.vue?vue&type=script&lang=ts"
export * from "./flow-item.vue?vue&type=script&lang=ts"

import "./flow-item.vue?vue&type=style&index=0&id=408d5652&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408d5652"]])

export default __exports__